module.exports = __webpack_public_path__ + "static/img/target.b809ca6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/share/home/target.png
// module id = iHuj
// module chunks = 0